import { store } from "../store";
import { call, put, takeLatest, takeEvery } from "redux-saga/effects";


import ENV from "../config/env";
import {
  ASSIGN_USERS_AS_ADMIN_REQUEST,
  GET_ACCREDITATIONDROPDOWN_DETAILS,
  GET_ADMIN_INFO_DETAILS_REQUEST,
  GET_BASIC_INFO_DETAILS_REQUEST,
  GET_DEMOGRAPHIC_INFO_DETAILS_REQUEST,
  GET_DOCUMENT_INFO_DETAILS_REQUEST,
  GET_EMPLOYEE_FLOW_STAGING_REQUEST,
  GET_HOSTEL_INFO_DETAILS_REQUEST,
  GET_KEYSPECIALDROPDOWN_DETAILS,
  GET_OTHER_INFO_DETAILS_REQUEST,
  GET_OWNERSHIP_INFO_DETAILS_REQUEST,
  GET_OWNERSHIPTYPEDROPDOWN_DETAILS,
  GET_SOCIAL_INFO_DETAILS_REQUEST,
  SAVE_ADMIN_INFO_DETAILS_REQUEST,
  SAVE_BASIC_INFO_DETAILS_REQUEST,
  SAVE_DEMOGRAPHIC_INFO_DETAILS_REQUEST,
  SAVE_DOCUMENT_INFO_DETAILS_REQUEST,
  SAVE_HOSTEL_INFO_DETAILS_REQUEST,
  SAVE_OTHER_INFO_DETAILS_REQUEST,
  SAVE_OWNERSHIP_INFO_DETAILS_REQUEST,
  SAVE_SOCIAL_INFO_DETAILS_REQUEST,
  SET_fLAG_AS_ADMIN_EMPLOYEE_FLOW_STAGING_REQUEST,
  UPDATE_EMPLOYEE_FLOW_STAGING_REQUEST,
} from "./employeeFlow.type";
import {
  saveBasicInfoSuccess,
  setEmployeeFlowSuccess,
} from "./employeeFlow.action";
import axiosInstance from "../../api/axiosInstance";

function getErrorMessage(error) {
  return (
    error?.response?.data?.message ||
    error?.response?.data?.error ||
    error.message ||
    "Something went wrong"
  );
}
function getAuthHeaders() {
  const token = store.getState()?.auth?.accessToken;
  return {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
}
function* assignUserAsAdminSaga(action) {

  const {
    payload: { user },
    callback,
  } = action;

  try {
    const { data } = yield call(
      axiosInstance.post,
      `${ENV.API_BASE_URL}${ENV.USER_SERVICE_URL}/update/UserRoles?id=${user}&roles=COMPANY_SUPER_ADMIN`,
      {},
      getAuthHeaders()
    );

    if (callback) yield call(callback, { success: true, data });
  } catch (error) {
    const msg = getErrorMessage(error);
    if (callback) yield call(callback, { success: false, error: msg });
  }
}

function* getBasicInfoDetailsSaga(action) {
  const {
    payload: { user },
    callback,
  } = action;

  try {
    const { data } = yield call(
      axiosInstance.post,
      `${ENV.API_BASE_URL}${ENV.COMPANY_SERVICES_URL}/get/CompanyBasicInfo?id=${user}`,
      {},
      getAuthHeaders()
    );

    if (callback) yield call(callback, { success: true, data });
  } catch (error) {
    const msg = getErrorMessage(error);
    if (callback) yield call(callback, { success: false, error: msg });
  }
}

function* saveBasicInfoSaga(action) {
  const { payload, callback } = action;

  try {
    const { data } = yield call(
      axiosInstance.post,
      `${ENV.API_BASE_URL}${ENV.COMPANY_SERVICES_URL}/save/CompanyBasicInfo`,
      payload,
      getAuthHeaders()
    );
    yield put(saveBasicInfoSuccess(data));
    if (callback) yield call(callback, { success: true, data });
  } catch (error) {
    const msg = getErrorMessage(error);
    if (callback) yield call(callback, { success: false, error: msg });
  }
}

function* getEmployeeStagingSaga(action) {
  const {
    payload: { user },
    callback,
  } = action;

  try {
    const { data } = yield call(
      axiosInstance.post,
      `${ENV.API_BASE_URL}${ENV.COMPANY_SERVICES_URL}/get/CurrentCompanyRegistrationStaging?id=${user}`,
      {},
      getAuthHeaders()
    );
    yield put(setEmployeeFlowSuccess(data));
    if (callback) yield call(callback, { success: true, data });
  } catch (error) {
    const msg = getErrorMessage(error);
    if (callback) yield call(callback, { success: false, error: msg });
  }
}
function* updateEmployeeStagingSaga(action) {
  const {
    payload: { user, stage },
    callback,
  } = action;

  try {
    const { data } = yield call(
      axiosInstance.post,
      `${ENV.API_BASE_URL}${ENV.COMPANY_SERVICES_URL}/update/CompanyRegistrationStaging?id=${user}&companyRegistrationStaging=${stage}`,
      {},
      getAuthHeaders()
    );

    if (callback) yield call(callback, { success: true, data });
  } catch (error) {
    const msg = getErrorMessage(error);
    if (callback) yield call(callback, { success: false, error: msg });
  }
}

function* setFlowForSuperAdminFlowSaga(action) {
  const {
    payload: { user, status },
    callback,
  } = action;

  try {
    const { data } = yield call(
      axiosInstance.post,
      `${ENV.API_BASE_URL}${ENV.COMPANY_SERVICES_URL}/save/IsSameAdminUsedAsSuperAdminFlag?id=${user}&isSameAdminUsedAsSuperAdmin=${status}`,
      {},
      getAuthHeaders()
    );

    if (callback) yield call(callback, { success: true, data });
  } catch (error) {
    const msg = getErrorMessage(error);
    if (callback) yield call(callback, { success: false, error: msg });
  }
}

function* getAdminInfoDetailsSaga(action) {
  const {
    payload: { user },
    callback,
  } = action;

  try {
    const { data } = yield call(
      axiosInstance.post,
      `${ENV.API_BASE_URL}${ENV.USER_SERVICE_URL}/get/User/Details/ByRoleAndCompanyId?companyId=${user}&roleType=COMPANY_SUPER_ADMIN`,
      {},
      getAuthHeaders()
    );

    if (callback) yield call(callback, { success: true, data });
  } catch (error) {
    const msg = getErrorMessage(error);
    if (callback) yield call(callback, { success: false, error: msg });
  }
}

function* saveAdminInfoSaga(action) {
  const { payload, callback } = action;

  try {
    const { data } = yield call(
      axiosInstance.post,
      `${ENV.API_BASE_URL}${ENV.USER_SERVICE_URL}/add/User/FromRegistrationFlow`,
      payload,
      getAuthHeaders()
    );

    if (callback) yield call(callback, { success: true, data });
  } catch (error) {
    const msg = getErrorMessage(error);
    if (callback) yield call(callback, { success: false, error: msg });
  }
}

function* getDemographicDetailsSaga(action) {
  const {
    payload: { user },
    callback,
  } = action;

  try {
    const { data } = yield call(
      axiosInstance.post,
      `${ENV.API_BASE_URL}${ENV.COMPANY_SERVICES_URL}/get/CompanyDemographicInfo?id=${user}`,
      {},
      getAuthHeaders()
    );

    if (callback) yield call(callback, { success: true, data });
  } catch (error) {
    const msg = getErrorMessage(error);
    if (callback) yield call(callback, { success: false, error: msg });
  }
}

function* saveDemographicInfoSaga(action) {
  const { payload, callback } = action;

  try {
    const { data } = yield call(
      axiosInstance.post,
      `${ENV.API_BASE_URL}${ENV.COMPANY_SERVICES_URL}/save/CompanyDemographicInfo`,
      payload,
      getAuthHeaders()
    );

    if (callback) yield call(callback, { success: true, data });
  } catch (error) {
    const msg = getErrorMessage(error);
    if (callback) yield call(callback, { success: false, error: msg });
  }
}

function* getOwnerShipDetailsSaga(action) {
  const {
    payload: { user },
    callback,
  } = action;

  try {
    const { data } = yield call(
      axiosInstance.post,
      `${ENV.API_BASE_URL}${ENV.COMPANY_SERVICES_URL}/get/CompanyOwnershipAndLegalInfo?id=${user}`,
      {},
      getAuthHeaders()
    );

    if (callback) yield call(callback, { success: true, data });
  } catch (error) {
    const msg = getErrorMessage(error);
    if (callback) yield call(callback, { success: false, error: msg });
  }
}

function* saveOwnerShipInfoSaga(action) {
  const { payload, callback } = action;

  try {
    const { data } = yield call(
      axiosInstance.post,
      `${ENV.API_BASE_URL}${ENV.COMPANY_SERVICES_URL}/save/CompanyOwnershipAndLegalInfo`,
      payload,
      getAuthHeaders()
    );

    if (callback) yield call(callback, { success: true, data });
  } catch (error) {
    const msg = getErrorMessage(error);
    if (callback) yield call(callback, { success: false, error: msg });
  }
}

function* getDocumentDetailsSaga(action) {
  const {
    payload: { user },
    callback,
  } = action;

  try {
    const { data } = yield call(
      axiosInstance.post,
      `${ENV.API_BASE_URL}${ENV.COMPANY_SERVICES_URL}/get/CompanyDocInfo?id=${user}`,
      {},
      getAuthHeaders()
    );

    if (callback) yield call(callback, { success: true, data });
  } catch (error) {
    const msg = getErrorMessage(error);
    if (callback) yield call(callback, { success: false, error: msg });
  }
}

function* saveDocumentInfoSaga(action) {
  const { payload, callback } = action;

  try {
    const { data } = yield call(
      axiosInstance.post,
      `${ENV.API_BASE_URL}${ENV.COMPANY_SERVICES_URL}/save/CompanyDocInfo`,
      payload,
      getAuthHeaders()
    );

    if (callback) yield call(callback, { success: true, data });
  } catch (error) {
    const msg = getErrorMessage(error);
    if (callback) yield call(callback, { success: false, error: msg });
  }
}

function* getOtherDetailsSaga(action) {
  const {
    payload: { user },
    callback,
  } = action;

  try {
    const { data } = yield call(
      axiosInstance.post,
      `${ENV.API_BASE_URL}${ENV.COMPANY_SERVICES_URL}/get/CompanyOtherDetails?id=${user}`,
      {},
      getAuthHeaders()
    );

    if (callback) yield call(callback, { success: true, data });
  } catch (error) {
    const msg = getErrorMessage(error);
    if (callback) yield call(callback, { success: false, error: msg });
  }
}

function* saveOtherDetailsSaga(action) {
  const { payload, callback } = action;

  try {
    const { data } = yield call(
      axiosInstance.post,
      `${ENV.API_BASE_URL}${ENV.COMPANY_SERVICES_URL}/save/CompanyOtherDetails`,
      payload,
      getAuthHeaders()
    );

    if (callback) yield call(callback, { success: true, data });
  } catch (error) {
    const msg = getErrorMessage(error);
    if (callback) yield call(callback, { success: false, error: msg });
  }
}

function* getHostelDetailsSaga(action) {
  const {
    payload: { user },
    callback,
  } = action;

  try {
    const { data } = yield call(
      axiosInstance.post,
      `${ENV.API_BASE_URL}${ENV.COMPANY_SERVICES_URL}/get/CompanyHostelDetails?id=${user}`,
      {},
      getAuthHeaders()
    );

    if (callback) yield call(callback, { success: true, data });
  } catch (error) {
    const msg = getErrorMessage(error);
    if (callback) yield call(callback, { success: false, error: msg });
  }
}

function* saveHostelDetailsSaga(action) {
  const { payload, callback } = action;

  try {
    const { data } = yield call(
      axiosInstance.post,
      `${ENV.API_BASE_URL}${ENV.COMPANY_SERVICES_URL}/save/CompanyHostelDetails`,
      payload,
      getAuthHeaders()
    );

    if (callback) yield call(callback, { success: true, data });
  } catch (error) {
    const msg = getErrorMessage(error);
    if (callback) yield call(callback, { success: false, error: msg });
  }
}

function* getSocialDetailsSaga(action) {
  const {
    payload: { user },
    callback,
  } = action;

  try {
    const { data } = yield call(
      axiosInstance.post,
      `${ENV.API_BASE_URL}${ENV.COMPANY_SERVICES_URL}/get/CompanySocialInfo?id=${user}`,
      {},
      getAuthHeaders()
    );

    if (callback) yield call(callback, { success: true, data });
  } catch (error) {
    const msg = getErrorMessage(error);
    if (callback) yield call(callback, { success: false, error: msg });
  }
}

function* saveSocialDetailsSaga(action) {
  const { payload, callback } = action;

  try {
    const { data } = yield call(
      axiosInstance.post,
      `${ENV.API_BASE_URL}${ENV.COMPANY_SERVICES_URL}/save/CompanySocialInfo`,
      payload,
      getAuthHeaders()
    );

    if (callback) yield call(callback, { success: true, data });
  } catch (error) {
    const msg = getErrorMessage(error);
    if (callback) yield call(callback, { success: false, error: msg });
  }
}

function* getKeySpecialitiesDropdownSaga(action) {
  const { payload, callback } = action;

  try {
    const { data } = yield call(
      axiosInstance.post,
      `${ENV.API_BASE_URL}${ENV.COMMAN_SERVICES_URL}/get/KeySpecialitiesDropdown`,
      {},
      getAuthHeaders()
    );

    if (callback) yield call(callback, { success: true, data });
  } catch (error) {
    const msg = getErrorMessage(error);
    if (callback) yield call(callback, { success: false, error: msg });
  }
}

function* getOwnershipTypeDropdownSaga(action) {
  const { payload, callback } = action;

  try {
    const { data } = yield call(
      axiosInstance.post,
      `${ENV.API_BASE_URL}${ENV.COMMAN_SERVICES_URL}/get/OwnershipTypeDropdown`,
      {},
      getAuthHeaders()
    );

    if (callback) yield call(callback, { success: true, data });
  } catch (error) {
    const msg = getErrorMessage(error);
    if (callback) yield call(callback, { success: false, error: msg });
  }
}
function* getAccredDropdownSaga(action) {
  const { payload, callback } = action;

  try {
    const { data } = yield call(
      axiosInstance.post,
      `${ENV.API_BASE_URL}${ENV.COMMAN_SERVICES_URL}/get/AccreditationDropdown`,
      {},
      getAuthHeaders()
    );

    if (callback) yield call(callback, { success: true, data });
  } catch (error) {
    const msg = getErrorMessage(error);
    if (callback) yield call(callback, { success: false, error: msg });
  }
}

export function* employeeFlowWatcherSaga() {
  yield takeLatest(ASSIGN_USERS_AS_ADMIN_REQUEST, assignUserAsAdminSaga);
  yield takeLatest(GET_BASIC_INFO_DETAILS_REQUEST, getBasicInfoDetailsSaga);
  yield takeLatest(SAVE_BASIC_INFO_DETAILS_REQUEST, saveBasicInfoSaga);
  yield takeLatest(GET_EMPLOYEE_FLOW_STAGING_REQUEST, getEmployeeStagingSaga);
  yield takeLatest(
    UPDATE_EMPLOYEE_FLOW_STAGING_REQUEST,
    updateEmployeeStagingSaga
  );
  yield takeLatest(GET_ADMIN_INFO_DETAILS_REQUEST, getAdminInfoDetailsSaga);

  yield takeLatest(SAVE_ADMIN_INFO_DETAILS_REQUEST, saveAdminInfoSaga);
  yield takeLatest(
    GET_DEMOGRAPHIC_INFO_DETAILS_REQUEST,
    getDemographicDetailsSaga
  );
  yield takeLatest(
    SAVE_DEMOGRAPHIC_INFO_DETAILS_REQUEST,
    saveDemographicInfoSaga
  );
  yield takeLatest(GET_OWNERSHIP_INFO_DETAILS_REQUEST, getOwnerShipDetailsSaga);
  yield takeLatest(SAVE_OWNERSHIP_INFO_DETAILS_REQUEST, saveOwnerShipInfoSaga);

  yield takeLatest(GET_DOCUMENT_INFO_DETAILS_REQUEST, getDocumentDetailsSaga);
  yield takeLatest(SAVE_DOCUMENT_INFO_DETAILS_REQUEST, saveDocumentInfoSaga);
  yield takeEvery(GET_OTHER_INFO_DETAILS_REQUEST, getOtherDetailsSaga);
  yield takeLatest(SAVE_OTHER_INFO_DETAILS_REQUEST, saveOtherDetailsSaga);
  yield takeLatest(GET_HOSTEL_INFO_DETAILS_REQUEST, getHostelDetailsSaga);
  yield takeLatest(SAVE_HOSTEL_INFO_DETAILS_REQUEST, saveHostelDetailsSaga);
  yield takeLatest(GET_SOCIAL_INFO_DETAILS_REQUEST, getSocialDetailsSaga);
  yield takeLatest(SAVE_SOCIAL_INFO_DETAILS_REQUEST, saveSocialDetailsSaga);
  yield takeLatest(
    GET_OWNERSHIPTYPEDROPDOWN_DETAILS,
    getOwnershipTypeDropdownSaga
  );
  yield takeLatest(
    GET_KEYSPECIALDROPDOWN_DETAILS,
    getKeySpecialitiesDropdownSaga
  );
  yield takeLatest(GET_ACCREDITATIONDROPDOWN_DETAILS, getAccredDropdownSaga);
  yield takeLatest(
    SET_fLAG_AS_ADMIN_EMPLOYEE_FLOW_STAGING_REQUEST,
    setFlowForSuperAdminFlowSaga
  );
}
